<template>
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 68 70"
    style="fill: currentColor;"
  >
    <circle style="opacity: 0.6;" cx="34.09" cy="12.53" r="7.58" />
    <circle cx="34.09" cy="35.32" r="7.58" />
    <circle style="opacity: 0.6;" cx="34.09" cy="58.11" r="7.58" />
    <circle style="opacity: 0.6;" cx="56.88" cy="35.32" r="7.58" />
    <circle style="opacity: 0.6;" cx="11.31" cy="35.32" r="7.58" />
  </svg>
</template>

<script>
export default {
  name: "core_counts"
};
</script>
